<template lang="pug">
  grid(
    name='Programs & Events',
    desc='Create and manage your programs and events'
    search=true
    resizing=false
    :endpoint='api.$.program.list'
    :filter='defaultFilter'
    alias='programGrid'
  )
</template>

<script>

import Grid from '@/components/Grid'
// import model from './model'
import model from '../Program-sent/model'

export default {
  components: {
    Grid
  },
  data() {
    return {
      model,
      defaultFilter: {
        ProgramOwner: { filter: this.$user.$.name }
      }
    }
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Program-list/index.vue